
<div class="dialog-header">
  <h2 mat-dialog-title>Upload File</h2>
  <button mat-icon-button class="close-button" (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
<div class="dialog-content-container">
<div class="drag-drop-zone" [class.is-dragging]="isDragging" (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
  <p>Drag and drop a file here or click to browse</p>
  <input type="file" #fileInput (change)="onFileSelected($event)" [accept]="getAllowedFileTypesString()" style="display: none;">
  <button mat-raised-button color="primary" (click)="fileInput.click()"><mat-icon fontSet="material-symbols-outlined">folder_open</mat-icon> Browse File</button>
</div>

<!-- Progress bar - only show during upload -->
@if(isBusy){
<div class="progress-section">
  <mat-progress-bar mode="determinate" [value]="uploadProgress" color="primary">
  </mat-progress-bar>
  <div class="progress-text">
    Uploading... {{uploadProgress}}%
  </div>
</div>
}

@if(errorMessage){
<div class="error-message m-t-1">
  <mat-error>{{errorMessage}}</mat-error>
</div>
}

@if(selectedFile){
<div class="selected-file m-t-1">
  <mat-card class="file-panel m-b-1">
    <mat-card-content class="d-flex">
      <div class="file-icon"><mat-icon fontSet="material-symbols-outlined" class="upload">attach_file</mat-icon></div>
      <div class="file-info">{{getTruncatedFileName(selectedFile.name)}}</div>
      <div class="file-size">({{selectedFile.size | byteFormat}})</div>
      <div class="file-actions"><button mat-icon-button (click)="removeFile()" aria-label="Remove file"><mat-icon
            fontSet="material-symbols-outlined" class="delete">delete</mat-icon></button></div>
    </mat-card-content>
  </mat-card>
</div>
}
</div>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-flat-button type="button" (click)="uploadFiles()"
    [disabled]="!selectedFile || isBusy || uploadDisabled"><mat-icon fontSet="material-symbols-outlined">upload</mat-icon> Upload</button>
  <button mat-flat-button type="button" class="cancel-button" (click)="removeFile()" [disabled]="removeDisabled || isBusy"><mat-icon fontSet="material-symbols-outlined">close</mat-icon> Remove File</button>
  @if (isBusy) {
    <button mat-flat-button class="cancel-button" type="button" (click)="cancelUpload()">Cancel Upload</button>
  }
</mat-dialog-actions>
